/* eslint-disable @typescript-eslint/no-non-null-assertion */
const cookieButtonChange = (button: Element) => {

  const cookieSDKBtn = document.querySelector("#ot-sdk-btn");
  const MutationObserver = window.MutationObserver;
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.target.textContent != "CookieSettings") {
        const otBtnText = document.querySelector('#ot-sdk-btn')?.textContent;
        const mainContent = button?.querySelector('span[slot="main-content"]');
        if (mainContent && otBtnText) {
          mainContent.innerHTML = otBtnText;
        }
      }
    });
  });

  const config = {attributes: true,  childList: true,  characterData: true};
  if (cookieSDKBtn) observer.observe(cookieSDKBtn, config);
};

export const cookieListener = () => {
  const shadowList = document.querySelectorAll('section[slot="legal-links"] cipublic-list')!;
  [...shadowList].forEach((shadowItem) => {
    const shadowLink = shadowItem?.shadowRoot?.querySelector('[href="#ot-cookie-btn"]');
    if (shadowLink != null) {
      cookieButtonChange(shadowLink);
      shadowLink.addEventListener('click', (e) => {
        e.preventDefault();
        const otButton: HTMLElement = document.querySelector('#ot-sdk-btn') as HTMLElement;
        if(otButton) {
          otButton.click();
        }
      });
    }
  });
};
